import React from 'react'

export default function Footer() {
    return (
        <div className='footer '>
           <h2 className='pt-5 text-xl'>Address: Montrael,  Street 10, Canada</h2>
           <h4 className='pt-5 text-sm'>© 2020 by Gomesia Biotech. </h4>
        </div>
    )
}